import { render, staticRenderFns } from "./ClipboardButton.vue?vue&type=template&id=34172dad"
import script from "./ClipboardButton.vue?vue&type=script&lang=ts"
export * from "./ClipboardButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports